module.exports = __webpack_public_path__ + "static/floor_preview__1-c99064da94059f8918248a2c2cb7fde3.png";